import { useRef, useEffect } from "react";

function AutoGrowTextarea({ value, onChange, ...props }) {
  const textareaRef = useRef(null);

  const resize = () => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  };

  useEffect(() => {
    resize(); // resize when component mounts or value changes
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value}

      onInput={(e) => {
        resize();
        onChange(e);
      }}
      className="resize-none lg:max-h-[400px] min-h-[120px] max-h-[400px] w-full overflow-y-auto border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      {...props}
    />
  );
}

export default AutoGrowTextarea;
